export default {
  en: {
    translation: {
      local: {
        browse: 'Browse',
        dd_title_single: 'Drag and Drop an asset here',
        dd_title_multi: 'Drag and Drop assets here',
        drop_title_single: 'Drop a file to upload',
        drop_title_multiple: 'Drop files to upload',
      },
    },
  },
};
